// extracted by mini-css-extract-plugin
export default {"navItem":"NavItem_navItem__v-HME","navItem__active":"NavItem_navItem__active__AsPkX","navItem__icon":"NavItem_navItem__icon__BhP5h","navItem__title":"NavItem_navItem__title__UdctN"};